import React from 'react';
import AssessmentPage from './AssessmentPage';
import { ASSESSMENTS } from './assessmentConfig';

const PigButcheringCryptoAssessment = (props) => (
  <AssessmentPage assessment={ASSESSMENTS['pig-butchering-crypto']} {...props} />
);

export default PigButcheringCryptoAssessment;
